module.exports = __webpack_public_path__ + "static/media/init.55b107a8.ogg";